import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import Login, { COSTS_SECTION_ID } from '../components/Auth/Login/Login'
import CostsOverview from '../components/Costs/CostsOverview'
import { SUBSCRIPTION_TAB_HREF } from '../components/Costs/costsLinks'
import { UserContext } from '../contexts/UserContext'

/**
 * /costs, for links (ticket 6ad5d51d). Without a session: the login page opened on its
 * Info & costs section, where the section lives. With a session: the same overview on
 * its own page, with the way back to the account.
 */
const CostsPage = () => {
  const { t } = useTranslation('costs')
  const context = useContext(UserContext)

  if (!context || context.loading) return <></>
  if (!context.isAuthenticated) return <Login revealCosts />

  return (
    <div
      data-testid="costs-page"
      className="w-screen h-screen overflow-y-auto overflow-x-hidden bg-dark-blue text-white"
    >
      <header className="sticky top-0 z-10 border-b border-white/10 bg-dark-blue/80 backdrop-blur">
        <div className="mx-auto flex w-full max-w-[1200px] items-center justify-between gap-4 px-5 py-4 tablet:px-10">
          <img src="/assets/images/flowleap-logo.svg" alt="LeaRes" className="h-8" />
          <Link
            to="/account"
            data-testid="costs-back-to-account"
            className="text-sm text-bright-blue underline-offset-4 hover:underline hover:text-white"
          >
            <span aria-hidden="true">← </span>
            {t('nav.backToAccount')}
          </Link>
        </div>
      </header>
      <CostsOverview
        id={COSTS_SECTION_ID}
        variant="landing"
        choosePlanHref={SUBSCRIPTION_TAB_HREF}
      />
    </div>
  )
}

export default CostsPage
